// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Fallbacks ensure the app still boots on the published domain if the build-time
// env vars were not injected. These are public (publishable/anon) values only.
const FALLBACK_SUPABASE_URL = 'https://yczpcdelenkrrzfjghoh.supabase.co';
const FALLBACK_SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InljenBjZGVsZW5rcnJ6ZmpnaG9oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkzNzY4NjksImV4cCI6MjA2NDk1Mjg2OX0.5yZ-pFqFg1ILLDePCNsaPBiCLQToX3WNhNkYaRxwjXg';

const SUPABASE_URL = import.meta.env['VITE_SUPABASE_URL'] || FALLBACK_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY'] || FALLBACK_SUPABASE_PUBLISHABLE_KEY;

if (!import.meta.env['VITE_SUPABASE_URL'] || !import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY']) {
  // eslint-disable-next-line no-console
  console.warn('[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY missing — using fallback configuration.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
